import { Switch, FormControlLabel } from '@mui/material';
import { styled } from '@mui/material/styles';

// Styled component with gradient effect
const GradientSwitch = styled(Switch)(({ theme }) => ({
    '& .MuiSwitch-switchBase': {
        '&.Mui-checked': {
            color: '#F5D01C',
            '& + .MuiSwitch-track': {
                background: 'linear-gradient(to right, #F5D01C, #826320)',
                opacity: 1,
            },
        },
    },
    '& .MuiSwitch-track': {
        backgroundColor: '#ccc',
    },
}));

const CommonGradientSwitch = ({
    label,
    labelPlacement = 'end',
    ...switchProps
}) => {
    if (label) {
        return (
            <FormControlLabel
                control={<GradientSwitch {...switchProps} />}
                label={label}
                labelPlacement={labelPlacement}
            />
        );
    }

    return <GradientSwitch {...switchProps} />;
};

export default CommonGradientSwitch;